import React from 'react';
import PropTypes from 'prop-types';
import exact from 'prop-types-exact';
import ReactTable from 'react-table';

import {
  Row,
  Col,
  Button,
} from 'react-bootstrap';

import {
  defaultTableFiltering,
  tableStringSorting,
} from '../../../utils';

import linkWithCredentials from '../../../utils/linkWithCredentials';
import { downloadingFileAndUpdatingCredentials } from '../../../utils/downloadUpdatingCredentials';

const propTypes = exact({
  allTimesheetsForAllUsers: PropTypes.array.isRequired,
  apiServerUrl: PropTypes.string.isRequired,
  apiStartDate: PropTypes.string.isRequired,
  apiEndDate: PropTypes.string.isRequired,
});


const TrirTable = (props) => {
  const {
    allTimesheetsForAllUsers,
    apiServerUrl,
    apiStartDate,
    apiEndDate,
  } = props;

  const openUrl = () => {
    const csvUrl = linkWithCredentials(`${apiServerUrl}/trir_report`);
    downloadingFileAndUpdatingCredentials(`${csvUrl}&start_date=${apiStartDate}&end_date=${apiEndDate}&with_headings=true`);
  };

  return (
    <React.Fragment>
      <Row>
        <Col md={12}>
          <Button
            onClick={openUrl}
            bsStyle="primary"
            className="pull-right"
          >Download Report
          </Button>
        </Col>
      </Row>
      <ReactTable
        className="-striped -highlight"
        filterable
        data={allTimesheetsForAllUsers}
        columns={[
          {
            Header: 'First Name',
            id: 'firstname',
            accessor: (e) => { return e.user.firstname; },
            filterMethod: (filter, row) => {
              const customFilterObj = {
                id: filter.id,
                value: filter.value,
              };
              return defaultTableFiltering(customFilterObj, row);
            },
          },
          {
            Header: 'Last Name',
            id: 'lastname',
            accessor: (e) => { return e.user.lastname; },
            filterMethod: (filter, row) => {
              const customFilterObj = {
                id: filter.id,
                value: filter.value,
              };
              return defaultTableFiltering(customFilterObj, row);
            },
          },
          {
            Header: 'District',
            id: 'defaultDistrict',
            accessor: (e) => { return e.user.defaultDistrict; },
            sortMethod: (a, b) => {
              return tableStringSorting(a, b, 'name');
            },
            filterMethod: (filter, row) => {
              const customFilterObj = {
                id: 'name',
                value: filter.value,
              };
              return defaultTableFiltering(customFilterObj, row.defaultDistrict);
            },
            Cell: (row) => {
              return (
                <div>
                  { row.original.user.defaultDistrict.name }
                </div>
              );
            },
          },
          {
            Header: 'Department',
            id: 'defaultDepartment',
            accessor: (e) => { return e.user.defaultDepartment; },
            sortMethod: (a, b) => {
              return tableStringSorting(a, b, 'name');
            },
            filterMethod: (filter, row) => {
              const customFilterObj = {
                id: 'name',
                value: filter.value,
              };
              return defaultTableFiltering(customFilterObj, row.defaultDepartment);
            },
            Cell: (row) => {
              return (
                <div>
                  {row.original.user.defaultDepartment.name}
                </div>
              );
            },
          },
          {
            Header: 'Total Paid Hours',
            id: 'paidTotalDuration',
            accessor: (e) => { return e.paidTotalDuration; },
            sortMethod: (a, b) => {
              return tableStringSorting(a, b, 'totalSeconds');
            },
            Cell: (row) => {
              return (
                <div>
                  {row.original.paidTotalDuration.toString}
                </div>
              );
            },
          },
          {
            Header: 'Paid Labor Hours',
            id: 'paidLaborDuration',
            accessor: (e) => { return e.paidLaborDuration; },
            sortMethod: (a, b) => {
              return tableStringSorting(a, b, 'paidLaborDuration');
            },
            Cell: (row) => {
              return (
                <div>
                  {row.original.paidLaborDuration.toString}
                </div>
              );
            },
          },
          {
            Header: 'Paid Non-Labor Hours',
            id: 'paidNonLaborDuration',
            accessor: (e) => { return e.paidNonLaborDuration; },
            sortMethod: (a, b) => {
              return tableStringSorting(a, b, 'totalSeconds');
            },
            Cell: (row) => {
              return (
                <div>
                  {row.original.paidNonLaborDuration.toString}
                </div>
              );
            },
          },
          {
            Header: 'PTO',
            id: 'pto',
            accessor: (e) => { return e.pto; },
            sortMethod: (a, b) => {
              return tableStringSorting(a, b, 'totalSeconds');
            },
            Cell: (row) => {
              return (
                <div>
                  {row.original.pto.toString}
                </div>
              );
            },
          },
          {
            Header: 'Guaranteed Time',
            id: 'guaranteed',
            accessor: (e) => { return e.guaranteed; },
            sortMethod: (a, b) => {
              return tableStringSorting(a, b, 'totalSeconds');
            },
            Cell: (row) => {
              return (
                <div>
                  {row.original.guaranteed.toString}
                </div>
              );
            },
          },
        ]}
      />
    </React.Fragment>
  );
};


TrirTable.propTypes = propTypes;


export default TrirTable;
